export const listRoles = async params => {
  return await window.$vue.$get({ endpoint: "/role", params })
}

export const listActiveRoles = async params => {
  return await window.$vue.$get({ endpoint: "/role/list-all", params })
}

export const listPermissions = async params => {
  return await window.$vue.$get({ endpoint: "/permission", params })
}

export const listReportPermissions = async params => {
  return await window.$vue.$get({ endpoint: "/permission/report", params })
}

export const listMenuPermissions = async params => {
  return await window.$vue.$get({ endpoint: "/menu/sidebar", params })
}

export const listHomePermissions = async params => {
  return await window.$vue.$get({ endpoint: "/menu/home", params })
}

export const listCategories = async params => {
  return await window.$vue.$get({ endpoint: "/role/list-categories", params })
}

export const fetchRole = async uuid => {
  return await window.$vue.$get({ endpoint: `/role/${uuid}` })
}

export const changeStatusRole = async (data, uuid) => {
  return await window.$vue.$put({
    endpoint: `/role/change-status/${uuid}`,
    data
  })
}

export const createRole = async data => {
  return await window.$vue.$post({ endpoint: "/role", data })
}

export const editRole = async (data, uuid) => {
  return await window.$vue.$put({ endpoint: "/role/" + uuid, data })
}

export const duplicateRole = async uuid => {
  return await window.$vue.$post({ endpoint: `/role/duplicate/${uuid}` })
}

export const getAllRoles = async () => {
  return await window.$vue.$get({ endpoint: "/role/list-all" })
}
